import {persistent_observable} from './storage.js';

export const whitelabel_info = persistent_observable('whitelabel_info', {});
